import { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { Modal, Button } from './ui';

/**
 * SlackMemberIdHelp
 *
 * Botón pequeño "¿Cómo obtener tu Slack Member ID?" que abre un Modal
 * con los 4 pasos. Se usa debajo de inputs de Slack Member ID en forms.
 */
const SlackMemberIdHelp = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                type="button"
                className="slack-help-toggle"
                onClick={() => setOpen(true)}
            >
                <HelpCircle size={12} aria-hidden="true" />
                <span>¿Cómo obtener tu Slack Member ID?</span>
            </button>

            <Modal
                open={open}
                onClose={() => setOpen(false)}
                title="Obtener tu Slack Member ID"
                size="sm"
                footer={
                    <Button variant="primary" size="sm" onClick={() => setOpen(false)}>
                        Entendido
                    </Button>
                }
            >
                <p className="text-sm text-muted mb-3">
                    Necesitas el Member ID de tu cuenta de Slack (formato <code className="slack-help-code">U07ABCDE123</code>) para que las alertas te etiqueten correctamente.
                </p>
                <ol className="slack-help-steps">
                    <li>Hacer click en tu <strong>foto / avatar</strong> en Slack</li>
                    <li>Seleccionar o presionar en <strong>Perfil</strong></li>
                    <li>Buscar los <strong>3 puntitos (⋮)</strong> y presionarlos</li>
                    <li>Click en <strong>Copiar ID de miembro</strong></li>
                </ol>
                <p className="text-xs text-muted mt-3">
                    Pega el ID copiado en el campo "Slack Member ID" del formulario.
                </p>
            </Modal>
        </>
    );
};

export default SlackMemberIdHelp;
